import React from 'react'

import { Box, Divider, Collapse } from '@material-ui/core'

interface B2CCardContentProps {
  collapsed?: boolean
  children?: React.ReactNode
}

export default function B2CCardContent({ collapsed, children }: B2CCardContentProps) {
  return (
    <Collapse in={!collapsed} timeout="auto">
      <Divider className="strong" />
      <Box display="flex" flexDirection="column" p={6}>
        {children}
      </Box>
    </Collapse>
  )
}
